module.exports = __webpack_public_path__ + "img/chenzhuo.5e82349c.jpg";